import * as R from "ramda";

export const validate = (controls, dataTable) => {
    const newErrors = {};
    if (controls) {
        for (const [key, data] of Object.entries(controls)) {
            if (data) {
                const message = validateEmptyValue(key, data, dataTable);
                if (message) {
                    newErrors[key] = message;
                }
            }
        }
    }
    return newErrors;
}

function validateEmptyValue(key, data, dataTable) {
    if (R.equals(key, "variants") && !R.isEmpty(dataTable.value)) {
        const result = dataTable.every(item => item.kodeVariant !== null) && dataTable.map(item => item.kodeVariant);
        if (!result || R.isEmpty(result)) {
            return "Ada field data yang perlu diisi atau tidak sesuai kriteria isian.";
        }
    }

    if (R.and(data.mandatory, R.or(!data.value, R.isEmpty(data.value)))) {
        return "Field belum diisi";
    }

    return null;
}

export const compareArray = (arr1, arr2) => {
    if (R.or(R.isNil(arr1), R.isNil(arr2))) return true;
    return !R.equals(arr1, arr2);
};

export function parseStringBBN(input) {
  const lines = input.split("\n");
  const moduleLine = lines.find(line => line.trim().startsWith("Type:"));
  const moduleSent = moduleLine ? moduleLine.replace("Type:", "").trim() : null;
  const displayView = lines
    .filter(line => !line.trim().startsWith("Type:"))
    .join("\n");

  return { displayView, moduleSent };
}